var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.074 3.484v2.09l2.787-2.787L6.074 0v2.09a5.564 5.564 0 0 0-4.71 8.542l1.017-1.017a4.09 4.09 0 0 1-.488-1.951 4.184 4.184 0 0 1 4.181-4.18zm4.71 1.216L9.767 5.714a4.173 4.173 0 0 1-3.693 6.132v-2.09l-2.787 2.786 2.787 2.787v-2.09a5.563 5.563 0 0 0 4.71-8.539z",
    fill: "#995EC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.492 7.406h-.194v-.58a1.226 1.226 0 0 0-2.452 0v.581h-.193a.387.387 0 0 0-.387.387v1.548a.387.387 0 0 0 .387.387h2.839a.387.387 0 0 0 .387-.387V7.794a.387.387 0 0 0-.387-.388zm-.84 0h-1.16v-.58a.581.581 0 0 1 1.16 0v.58z",
    fill: "#995EC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPin);
export default __webpack_public_path__ + "static/media/reset-pin.99ba242349da11fc980060d81b62634b.svg";
export { ForwardRef as ReactComponent };